/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '../utils/text';
import CSRFToken from 'components/CSRFToken';
import { ErrorsShape } from '../utils/shapes';
import NonFieldErrors from 'components/inputs/NonFieldErrors';
import UploadBox from 'components/UploadBox';
import TrafoPreview from './TrafoPreview';
import DeleteButton from './DeleteButton';

class AvatarProfilePic extends React.Component {
    static propTypes = {
        accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        initialAvatar: PropTypes.string,
        errors: ErrorsShape,
    };

    static defaultProps = {
        accept: undefined,
        initialAvatar: null,
        errors: {},
    };

    static emptyState = {
        showPreview: true,
        media: null,
        file: null,
        fileId: Math.random(),
        errorMessage: null,
    };

    constructor(props) {
        super(props);
        const initialState = {
            ...AvatarProfilePic.emptyState,
        };
        this.state = initialState;
    }

    componentWillUnmount() {
        // Revoke preview to avoid memory leaks
        if (this.state.file) {
            window.URL.revokeObjectURL(this.state.file);
        }
    }

    onDrop(acceptedFiles, rejectedFiles) {
        this.setState({
            showPreview: true,
        });
        if (acceptedFiles.length > 0) {
            const acceptedFile = acceptedFiles[0];
            this.setState({
                file: acceptedFile,
            });
        }
        if (acceptedFiles.length > 1) {
            this.setState({
                errorMessage: gettext('You can only upload one work at a time.'),
            });
        }
        if (rejectedFiles.length > 0) {
            this.setState({
                errorMessage: gettext('Some of the file(s) you uploaded were rejected because of their type'),
            });
        }
    }

    deleteMedia() {
        if (this.state.showPreview) {
            this.setState({
                showPreview: false,
            });
        }
        if (this.state.file) {
            window.URL.revokeObjectURL(this.state.file);
            this.setState({
                file: null,
                fileId: Math.random(),
            });
        }
    }

    canSubmit() {
        if (!this.state.file) return false;
        return true;
    }

    render() {
        let displayPreview = this.state.showPreview && (this.state.file || this.props.initialAvatar);
        let content = (
            <div className="d-flex flex-column">
                <img
                    className="col-sm-12 pl-0 pr-0"
                    src={(this.state.file && this.state.file.preview) || this.props.initialAvatar}
                    style={{
                        display: !displayPreview && 'none',
                    }}
                />
                <div
                    style={{
                        display: displayPreview && 'none',
                    }}
                >
                    <UploadBox
                        key={this.state.fileId}
                        onDrop={(...args) => this.onDrop(...args)}
                        accept={this.props.accept}
                        multiple={false}
                        name="avatar"
                    />
                </div>
                <div
                    style={{
                        display: !displayPreview && 'none',
                    }}
                    className="ml-auto mr-auto mt-2"
                >
                    <DeleteButton onClick={() => this.deleteMedia()} />
                </div>
            </div>
        );
        return (
            <div className="upload-work col-md-5 pl-0 pr-0">
                <form method="post" noValidate="noValidate" enctype="multipart/form-data" classNames="">
                    <CSRFToken />
                    {content}
                    {this.state.errorMessage && <div className="alert alert-danger">{this.state.errorMessage}</div>}
                    <NonFieldErrors error={this.props.errors.__all__} />
                    <button className="btn btn-primary mt-4 col-md-6 col-md-offset-3" type="submit">
                        {gettext('Upload')}
                    </button>
                </form>
            </div>
        );
    }
}

export default AvatarProfilePic;



// WEBPACK FOOTER //
// ./src/components/AvatarProfilePic.js